if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      // Always call fetchAvailability - if dataset.variantId is empty, fetch the section without a variant for unavailable items
      this.fetchAvailability(this.dataset.variantId ?? '');
    }

    /* ----- Fetches availability of variants from pickup-availability.liquid ----- */
    fetchAvailability(variantId) {
      // Cancel any previous request so we don't load the wrong variant
      if (this._fetchController) {
        try { this._fetchController.abort(); } catch (e) {}
      }
      this._fetchController = new AbortController();
      const signal = this._fetchController.signal;

      // Make sure the root URL ends with a slash
      let rootUrl = this.dataset.rootUrl || '/';
      if (!rootUrl.endsWith("/")) rootUrl = rootUrl + "/";

      // Build the correct section URL (with or without variant)
      const variantSectionUrl = variantId
        ? `${rootUrl}variants/${variantId}/?section_id=pickup-availability`
        : `${rootUrl}?section_id=pickup-availability`;
      // Clear previous "available" state while loading
      this.removeAttribute('available');

      fetch(variantSectionUrl, { signal })
        .then(response => response.text())
        .then(text => {
          // Ignore if this request was aborted
          if (signal.aborted) return;
          // Parse the returned HTML and extract the section
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          // Ignore abort errors
          if (e.name === 'AbortError') return;
          // Clean up and show error UI
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    /* ----- Show pickup availability for the current variant ----- */
    renderPreview(sectionInnerHTML) {
      if (!sectionInnerHTML) {
        this.renderError();
        return;
      }
      // If a drawer from previous variant exists - remove it to avoid duplicates.
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      // No pickup available
      const previewEl = sectionInnerHTML.querySelector('pickup-availability-preview');
      if (!previewEl) {
        // Remove"available" attribute from previous variant state
        this.removeAttribute('available');
        this.innerHTML = '';
        return;
      }
      // Normal case: pickup available
      this.innerHTML = previewEl.outerHTML;
      this.setAttribute('available', '');
      const drawerEl = sectionInnerHTML.querySelector('pickup-availability-drawer');
      if (drawerEl) document.body.appendChild(drawerEl);
      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        const drawerNode = document.querySelector('pickup-availability-drawer');
        if (drawerNode) drawerNode.show(evt.target);
      });
    }
    
    // Refresh pickup availability
    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }
    // Render any errors
    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);
      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }
  });
}

// Defines how the pickup availability drawer opens, closes, and handles outside clicks
if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });
      this.addEventListener('keyup', () => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }
    handleBodyClick(evt) {
      const target = evt.target;
      console.log(target.className)
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer' || target.className === "popup-modal") {
        this.hide();
      }
    }
    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }
    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}